/**
 * Enterprise ERP table class names.
 * Container, header, and row styles live in theme-compat.css.
 */

export const erpTableShellClass = 'erp-table-shell';
export const erpTableScrollClass = 'erp-table-scroll';
export const erpTableHeadRowClass = 'erp-table-head-row';
export const erpTableHeadCellClass = 'erp-table-head-cell';
export const erpTableToolbarClass = 'erp-table-toolbar';
export const erpTableEmptyClass = 'erp-table-empty';

export const erpTableRowBaseClass = 'erp-table-row';
export const erpTableRowInteractiveClass = 'erp-table-row erp-table-row--interactive';
export const erpTableRowSelectedClass = 'erp-table-row--selected';

export type ErpTableRowOptions = {
  interactive?: boolean;
  selected?: boolean;
};

/** Compose table row classes for `<tr>` elements. */
export function erpTableRowClasses(options: ErpTableRowOptions = {}): string {
  const { interactive = false, selected = false } = options;
  const classes = [erpTableRowBaseClass];
  if (interactive) classes.push('erp-table-row--interactive');
  if (selected) classes.push(erpTableRowSelectedClass);
  return classes.join(' ');
}

/** Standard `<table>` class for ERP data grids. */
export const erpTableClass = 'erp-table w-full border-collapse';
